<template>
  <v-card class="idea-card rounded-xl overflow-hidden" dark elevation="0" @click="$emit('click')">
    <div v-if="firstImage" class="idea-image-wrap">
      <SecuredMedia :src="attachmentPath(firstImage)" media-type="image" />
    </div>
    <div v-else-if="firstAttachment" class="idea-image-wrap idea-image-placeholder d-flex align-center justify-center">
      <v-icon size="40" :color="categoryColor(firstAttachment)">{{ attachmentIcon(firstAttachment) }}</v-icon>
    </div>

    <v-card-text class="pa-4">
      <div class="d-flex align-center justify-space-between mb-2">
        <div class="d-flex align-center">
          <v-avatar size="24" color="grey darken-3" class="mr-2">
            <span class="text-caption">{{ initials }}</span>
          </v-avatar>
          <span class="text-caption grey--text">{{ idea.authorName || "Unbekannt" }}</span>
        </div>
        <span class="text-caption grey--text">{{ formatDate(idea.createdAt) }}</span>
      </div>

      <h3 class="text-subtitle-1 font-weight-bold white--text mb-2">{{ idea.title }}</h3>
      <p class="text-body-2 grey--text text--lighten-1 line-clamp-3 mb-3">{{ idea.description }}</p>

      <v-divider class="mb-2 border-white-05"></v-divider>

      <div class="d-flex justify-space-between align-center">
        <v-btn text x-small :color="idea.likedByMe ? '#F44336' : 'grey'" @click.stop="$emit('like', idea._id)">
          <v-icon small left>{{ idea.likedByMe ? "mdi-heart" : "mdi-heart-outline" }}</v-icon>
          {{ idea.likeCount != null ? idea.likeCount : (idea.likes ? idea.likes.length : 0) }}
        </v-btn>
        <v-btn text x-small color="grey" @click.stop="$emit('click')">
          <v-icon small left>mdi-comment-outline</v-icon>
          {{ idea.commentCount != null ? idea.commentCount : (idea.comments ? idea.comments.length : 0) }}
        </v-btn>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import api from "@/api"
import SecuredMedia from "./SecuredMedia.vue"

export default {
  name: "IdeaCard",
  components: { SecuredMedia },
  props: {
    idea: { type: Object, required: true },
  },
  computed: {
    firstAttachment() {
      return this.idea.attachments && this.idea.attachments[0]
    },
    firstImage() {
      const a = this.firstAttachment
      return a && a.mimeType && a.mimeType.startsWith("image/") ? a : null
    },
    initials() {
      const n = this.idea.authorName || ""
      const parts = n.trim().split(/\s+/)
      return ((parts[0] || "?")[0] + (parts[1] ? parts[1][0] : "")).toUpperCase()
    },
  },
  methods: {
    attachmentPath(att) {
      return api.akademie.getIdeaAttachmentPath(this.idea._id, att.fileId)
    },
    attachmentIcon(att) {
      if (!att || !att.mimeType) return "mdi-file-outline"
      if (att.mimeType.startsWith("video/")) return "mdi-video-outline"
      if (att.mimeType.startsWith("audio/")) return "mdi-music-note-outline"
      if (att.mimeType === "application/pdf") return "mdi-file-pdf-box"
      return "mdi-file-outline"
    },
    categoryColor(att) {
      if (!att || !att.mimeType) return "#bdbdbd"
      if (att.mimeType.startsWith("video/")) return "#ef5350"
      if (att.mimeType.startsWith("audio/")) return "#ab47bc"
      if (att.mimeType === "application/pdf") return "#e53935"
      return "#bdbdbd"
    },
    formatDate(date) {
      if (!date) return ""
      return new Date(date).toLocaleDateString("de-CH")
    },
  },
}
</script>

<style scoped>
.idea-card {
  background: rgba(30, 30, 30, 0.85) !important;
  border: 1px solid rgba(255, 255, 255, 0.05);
  transition: all 0.3s ease;
  cursor: pointer;
  break-inside: avoid;
  margin-bottom: 24px;
}
.idea-card:hover {
  transform: translateY(-4px);
  border-color: rgba(212, 175, 55, 0.4);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.5), 0 0 12px rgba(212, 175, 55, 0.1);
}
.idea-image-wrap {
  max-height: 280px;
  overflow: hidden;
}
.idea-image-wrap :deep(.secured-media-content) {
  width: 100%;
  display: block;
  border-radius: 0;
}
.idea-image-placeholder {
  height: 140px;
  background: rgba(0, 0, 0, 0.3);
}
.line-clamp-3 {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.border-white-05 {
  border-color: rgba(255, 255, 255, 0.05) !important;
}
</style>
